// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { selectIsAuthenticated } from "../../redux/slices/auth/authSelectors";

// function ProtectedRoute() {
//   const isLogin = useSelector(selectIsAuthenticated);
//   return isLogin === true ? <Outlet /> : <Navigate to={""} />;
// }

// export default ProtectedRoute;

import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  selectIsAuthenticated,
} from "../../redux/slices/auth/authSelectors";
import { UserRoles } from "../Common/Sidebar";

const ProtectedRoute = ({ allowedRoles = [] }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const currentUserDetails = useSelector((state) => state.auth.user) || {};
  const location = useLocation();

  const roleName = UserRoles[currentUserDetails?.data?.role?.type];

  const isAllowed = allowedRoles.includes(roleName);

  if (!isAuthenticated)
    return <Navigate to="/login" state={{ from: location }} replace />;
  if (allowedRoles.length && !isAllowed)
    return <Navigate to="/" replace />;

  return <Outlet />;
};

export default ProtectedRoute;
